document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll("#clinics-review-videos-section video");

  videos.forEach((video) => {
    video.muted = true;

    video.addEventListener("click", (e) => {
      // Prevent browser from toggling play/pause
      e.preventDefault();
      e.stopPropagation();

      // Force unmute and continue playing
      video.muted = false;

      // Re-play if browser tried to pause it
      if (video.paused) {
        video.play().catch(() => {});
      }
    });
  });
});

// Lazy-Loaded Autoplay Implementation
window.addEventListener('load', () => {
  const lazyVideos = document.querySelectorAll('video[data-autoplay-lazy]');
  if (lazyVideos.length === 0) return;

  const videoObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const video = entry.target;
        const sources = video.querySelectorAll('source');
        sources.forEach(source => {
          if (source.dataset.src) {
            source.src = source.dataset.src;
          }
        });
        
        video.load();
        video.play().catch(() => {});
        observer.unobserve(video);
      }
    });
  }, { rootMargin: '200px 0px' });

  lazyVideos.forEach(v => videoObserver.observe(v));
});